import React from "react";
import { useParams } from "react-router-dom";

const CancellationAndRefund = () => {
  const { lang } = useParams();

  return (
    <div
      className="container d-flex justify-content-center align-items-center min-vh-100 px-3"
      style={lang === "ar" ? { direction: "rtl" } : {}}
    >
      <div className="card w-100 w-md-75 w-lg-50">
        <div className="card-body">
          <h1 className="card-title text-center fs-4">
            {lang === "ar" ? "الإلغاء والاسترداد" : "Cancellation and Refund"}
          </h1>
          <p className={`card-text ${lang === "ar" ? "me-4" : ""} `}  >
            {lang === "ar"
              ? "يمكنك إدارة أو إلغاء اشتراكك مباشرة من خلال حسابك على Google Play:"
              : "You can manage or cancel your subscription directly through your Google Play account:"}
          </p>
          <ol className="list-group list-group-numbered mb-3">
            <li className="list-group-item">
              {lang === "ar" ? "افتح تطبيق متجر Google Play." : "Open the Google Play Store app."}
            </li>
            <li className="list-group-item">
              {lang === "ar" ? (
                <>
                  اضغط على أيقونة ملفك الشخصي واختر{" "}
                  <strong>المدفوعات والاشتراكات</strong> &gt;{" "}
                  <strong>الاشتراكات</strong> أو يمكنك الإلغاء مباشرة من هنا:{" "}
                </>
              ) : (
                <>
                  Tap your profile icon and select{" "}
                  <strong>Payments & Subscriptions</strong> &gt;{" "}
                  <strong>Subscriptions</strong> or directly you can cancel from here:{" "}
                </>
              )}
              <a
                href="https://play.google.com/store/account/subscriptions"
                className="text-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                {lang === "ar" ? " اشتراكات Google Play" : " Google Play Subscriptions"}
              </a>
              .
            </li>
            <li className="list-group-item">
              {lang === "ar"
                ? "اختر Khat واتبع التعليمات لإلغاء أو تعديل اشتراكك."
                : "Select Khat and follow the instructions to cancel or modify your subscription."}
            </li>
          </ol>
          <ul className="list-group mb-3">
            <li className="list-group-item">
              {lang === "ar"
                ? "إلغاء الاشتراك سيوقف التجديد التلقائي، ولكن سيظل لديك حق الوصول إلى الميزات المدفوعة حتى نهاية فترة الفوترة الحالية."
                : "Canceling a subscription will stop auto-renewal, but you will retain access to paid features until the end of the current billing period."}
            </li>
            <li className="list-group-item">
              {lang === "ar"
                ? "تتم معالجة طلبات الاسترداد من خلال Google Play وتخضع لسياسة الاسترداد الخاصة بهم. نحن لا نقدم استردادًا مباشرًا."
                : "Refunds are handled by Google Play and are subject to their refund policy. We do not provide refunds directly."}
            </li>
            <li className="list-group-item">
              {lang === "ar"
                ? "إذا كنت تعتقد أنك مؤهل للحصول على استرداد، يرجى الاتصال بدعم Google Play."
                : "If you believe you are eligible for a refund, please contact Google Play Support."}
            </li>
          </ul>
          <h2 className="h5 text-center">
            {lang === "ar" ? "تغييرات في خطط الاشتراك" : "Changes to Subscription Plans"}
          </h2>
          <ul className="list-group">
            <li className="list-group-item">
              {lang === "ar"
                ? "نحتفظ بالحق في تعديل أسعار أو شروط الاشتراك في أي وقت. لن تؤثر التغييرات على الاشتراكات النشطة خلال فترة الفوترة الحالية."
                : "We reserve the right to modify subscription prices or terms at any time. Changes will not affect active subscriptions during the current billing period."}
            </li>
            <li className="list-group-item">
              {lang === "ar"
                ? "سيتم إخطارك بأي تغييرات مسبقًا، واستمرارك في استخدام الاشتراك يعني قبولك للشروط الجديدة."
                : "You will be notified of any changes in advance, and your continued use of the subscription implies acceptance of the new terms."}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
  
};

export default CancellationAndRefund;
